import Swiper from 'swiper/bundle';


// Main Frontend JS

document.addEventListener('DOMContentLoaded', function () {
    // Sticky Header
    const header = document.querySelector('header');
    const logoLight = document.querySelector('.logo-light');
    const logoDark = document.querySelector('.logo-dark');

    // Check if elements exist to avoid errors on pages without header
    if (header) {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 50) {
                header.classList.add('header-sticky');
                // Switch to dark logo
                if (logoLight && logoDark) {
                    logoLight.classList.add('d-none');
                    logoDark.classList.remove('d-none');
                }
            } else {
                header.classList.remove('header-sticky');
                // Switch to light logo
                if (logoLight && logoDark) {
                    logoLight.classList.remove('d-none');
                    logoDark.classList.add('d-none');
                }
            }
        });
    }


    // Initialize Swiper for Service Grids (Why Choose Us Module)
    // if (document.querySelector('.swiper-service-grids')) {
    //     const swiper = new Swiper('.swiper-service-grids', {
    //         loop: true,
    //         spaceBetween: 30,
    //         autoplay: {
    //             delay: 1000,
    //             disableOnInteraction: false,
    //             pauseOnMouseEnter: true,
    //         },
    //         pagination: {
    //             el: '.swiper-pagination',
    //             clickable: true,
    //         },
    //         breakpoints: {
    //             0: {
    //                 slidesPerView: 1,
    //             },
    //             768: {
    //                 slidesPerView: 2,
    //             },
    //             1024: {
    //                 slidesPerView: 3,
    //             }
    //         }
    //     });
    // }
});
